import { get, set, clear } from './favourite';

export default { get, set, clear };
